import MeshObjectCreator from "../mesh-object-creator.js";
import MultiObject from "./multi-object.js";

function getMaterialSingle(material, key) {
    if (Array.isArray(material)) {
        return material.map(mat => mat.materials[key]);
    } else {
        return material.materials[key];
    }
}

class MeshObjectMultiCreator extends MeshObjectCreator {
    constructor(creators) {
        super();
        this._creators = Object.assign({}, creators);
    }

    create(geometry, material) {
        const objects = {};

        for (const key in this._creators) {
            objects[key] = this._creators[key].create(geometry, getMaterialSingle(material, key));
        }

        return new MultiObject(objects);
    }

    dispose(object) {
        for (const key in this._creators) {
            this._creators[key].dispose(object.objects[key]);
        }
    }

    setGeometry(object, geometry) {
        for (const key in this._creators) {
            this._creators[key].setGeometry(object.objects[key], geometry);
        }
    }

    setMaterial(object, material) {
        for (const key in this._creators) {
            this._creators[key].setMaterial(object.objects[key], getMaterialSingle(material, key));
        }
    }
}

export default MeshObjectMultiCreator;
